import React from 'react';
import PropTypes from 'prop-types';
import {
  EnvelopeSimple,
  LinkSimple,
  Phone,
} from '@phosphor-icons/react';

import { DELIVERY_METHOD_LABELS, FAX_STATUS_LABELS } from './invitationUtils';
import './invitationDeliveryBadges.scss';

const DELIVERY_ICONS = {
  email: EnvelopeSimple,
  fax: Phone,
  link: LinkSimple,
};

const joinClasses = (...classes) => classes.filter(Boolean).join(' ');

const InvitationDeliveryBadges = ({ invitation, className }) => {
  const deliveryMethod = invitation?.delivery_method;
  const deliveryLabel = DELIVERY_METHOD_LABELS[deliveryMethod];

  if (!deliveryLabel) return null;

  const DeliveryIcon = DELIVERY_ICONS[deliveryMethod];
  const faxStatus = deliveryMethod === 'fax' ? invitation?.fax_status : null;
  const faxStatusLabel = faxStatus ? FAX_STATUS_LABELS[faxStatus] : null;
  const faxStatusSlug = faxStatus ? faxStatus.replace(/_/g, '-') : null;

  return (
    <div className={joinClasses('invitation-delivery-badges', className)}>
      <span
        className={joinClasses(
          'invitation-delivery-badges__pill',
          'invitation-delivery-badges__pill--delivery',
          `invitation-delivery-badges__pill--delivery-${deliveryMethod}`,
        )}
      >
        <DeliveryIcon size={12} />
        {deliveryLabel}
      </span>
      {faxStatusLabel && (
        <span
          className={joinClasses(
            'invitation-delivery-badges__pill',
            'invitation-delivery-badges__pill--status',
            `invitation-delivery-badges__pill--status-${faxStatusSlug}`,
          )}
        >
          {faxStatusLabel}
        </span>
      )}
    </div>
  );
};

InvitationDeliveryBadges.propTypes = {
  className: PropTypes.string,
  invitation: PropTypes.shape({
    delivery_method: PropTypes.string,
    fax_status: PropTypes.string,
  }),
};

InvitationDeliveryBadges.defaultProps = {
  className: '',
  invitation: null,
};

export default InvitationDeliveryBadges;
